import React from "react"

class HousekeepingStaffRoomsRow extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            checked: this.props.checked
        }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps && nextProps.checked !== this.props.checked) {
            this.setState({ checked: nextProps.checked });
        }
    }

    render() {
        var self = this;
        var mergedProps = $.extend({}, self.props, self.state);
        var columns = this.props.headers.map(function (header) {
            return (
                <td key={header.column_name} style={typeof header.text_align != 'undefined' ? { textAlign: header.text_align, width: (100 / mergedProps.headers.length) + '%' } : { width: (100 / mergedProps.headers.length) + '%'}}>{DataTypeHelper.renderColumn(header.data_type, self.props.row[header.column_name], mergedProps, header)}</td>
                );
            });
            
        columns.unshift(<td key='checkbox_col' className="col-md-1 col-checkbox"><input type="checkbox" name={this.props.inputName('[rooms_ids][]')} value={this.props.row.id ? this.props.row.id : JSON.stringify(this.props.row.id_fields)} checked={this.props.isChecked(this.props.row.id)} onChange={this.props.onChangeRoom.bind(null, this.props.row)} /></td>);


        return (
          <tr key={this.props.row.id ? this.props.row.id : JSON.stringify(this.props.row.id_fields)} className={this.state.checked ? 'checked' : null} >
                {columns}
            </tr>
        );
    }

};

export default HousekeepingStaffRoomsRow